import { validateQueryParams } from '../../utils/api/api-utils';
import {
  doGetQCXRequest,
  doPostQCXRequest,
  doPutQCXActivateRequest,
  doPutQCXInactivateRequest,
  doPutQCXRequest,
} from '../../utils/api/domain/domain-api-utils';
import { FILTER_ENDPOINT, TRANSPORTADORA_ENDPOINT } from '../../utils/api/domain/domain-endpoint-utils';

export async function fetchAll() {
  return doGetQCXRequest([
    TRANSPORTADORA_ENDPOINT
  ]);
}
export async function fetchByFilter(params = []) {
  const validatedParams = validateQueryParams(params);

  if (validatedParams.length) {
    return doGetQCXRequest([
      TRANSPORTADORA_ENDPOINT, FILTER_ENDPOINT
    ], validatedParams);
  }

  return { data: [] };
}

export async function fetchById(id) {
  return doGetQCXRequest([
    TRANSPORTADORA_ENDPOINT,
    id
  ]);
}

export async function register(data, queryParams = []) {
  return doPostQCXRequest(
    [TRANSPORTADORA_ENDPOINT],
    data,
    queryParams
  );
}

export async function save(data, queryParams = []) {
  return doPutQCXRequest(
    [TRANSPORTADORA_ENDPOINT],
    data,
    queryParams
  );
}

export async function activateById(id) {
  return doPutQCXActivateRequest(
    [TRANSPORTADORA_ENDPOINT],
    id
  );
}

export async function inactivateById(id) {
  return doPutQCXInactivateRequest(
    [TRANSPORTADORA_ENDPOINT],
    id
  );
}
